const API_URL = process.env.REACT_APP_API_URL || '';

const api = {
  getExercises: () => 
    fetch(`${API_URL}/api/exercises`).then(r => r.json()),
  
  addExercise: (data) => 
    fetch(`${API_URL}/api/exercises`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    }).then(r => r.json()),
  
  updateExercise: (id, data) => 
    fetch(`${API_URL}/api/exercises/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    }).then(r => r.json()),
  
  deleteExercise: (id) => 
    fetch(`${API_URL}/api/exercises/${id}`, {
      method: 'DELETE'
    }).then(r => r.json()),
  
  getSessions: () => 
    fetch(`${API_URL}/api/sessions`).then(r => r.json()),
  
  addSession: (data) => 
    fetch(`${API_URL}/api/sessions`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    }).then(r => r.json()),
  
  deleteSession: (id) => 
    fetch(`${API_URL}/api/sessions/${id}`, {
      method: 'DELETE'
    }).then(r => r.json())
};

export default api;
